import DropdownList from "../../DropdownList";
import { useFindOrganizationsMapStore } from "../store";

export default function MapDropdownList() {
    const {
        suggestions,
        suggestionsIsLoading,
        showSuggestions,
        setInputValue,
        getOrganizations,
        setShowSuggestions,
        setExpandendResults,
        fairIsChecked,
        bransch,
    } = useFindOrganizationsMapStore();

    const handleSuggestionsClick = (e) => {
        if (e === "outsideclick") {
            setShowSuggestions(false);
            return;
        }

        setInputValue(e.target.textContent);
        getOrganizations(bransch, e.target.textContent, fairIsChecked);
        setShowSuggestions(false);
        setExpandendResults(true);
    };
    return suggestions.suggestions?.length < 10 &&
        !suggestionsIsLoading &&
        suggestions.suggestions?.length > 0 &&
        showSuggestions ? (
        <DropdownList
            list={suggestions.suggestions}
            onClick={handleSuggestionsClick}
        />
    ) : null;
}
